import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListSubheader,
} from "@mui/material";
import { GiNightSleep, GiNotebook } from "react-icons/gi";
import { useDispatch } from "react-redux";
import { dialogSlice } from "../../data/dialogSlice";

export default function LogActionList() {
  const dispatch = useDispatch();

  const logItems = [
    {
      icon: <GiNotebook />,
      text: "Note",
      action: () => dispatch(dialogSlice.actions.openNoteDialog()),
    },
    {
      icon: <GiNightSleep />,
      text: "Sweepy",
      action: () => dispatch(dialogSlice.actions.openSleepDialog()),
    },
  ];

  return (
    <>
      <ListSubheader>Logging</ListSubheader>
      {logItems.map((item) => (
        <ListItem disablePadding key={item.text}>
          <ListItemButton onClick={item.action}>
            <ListItemIcon>{item.icon}</ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItemButton>
        </ListItem>
      ))}
    </>
  );
}
